import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SalesService } from '../../sales.service';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../../services/common/common.service';
import { ModalService } from '../../../../services/common/modal.service';
declare const $: any
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from '../../../../services/common';
import { environment } from '../../../../../environments/environment';
import { IconList } from '../../../../../iconlist';
import { CurrentRecordAndState } from '../customer-list.model';
import { ToasterService } from '../../../../services/common/toaster.service';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrl: './client-list.component.scss'
})
export class ClientListComponent {
  @Input() customerListData: any;
  @Output() changeModelStatus = new EventEmitter<CurrentRecordAndState>();

  customerForm!: FormGroup
  filterTerm!: any;
  gridOptions: any;
  Submitted = false;
  columnDefs!: any[];
  defaultColDef: any;
  frameworkComponents: any;
  isVisible: boolean = false;
  excelStyles: any[] = [];
  showOverlay: boolean = false;
  showClient: boolean = false;
  showExport: boolean = false;
  exportSelectedType: string = '';
  searchText: string = '';
  context: any;
  fileName = '';
  currentSelectedRecourd: any;
  showaddUpdateModal: boolean = false
  isDropdownOpen = false;
  exportButton: string = environment.assetsImagePath + IconList.exportButtonIcon
  addButton: string = environment.assetsImagePath + IconList.AddbuttonIcon
  editIcon = environment.assetsImagePath + IconList.EditIconDropdown;
  selectedExportData: any[] = [];
  /**
   * Export data Common Module through ExportList Component
   */
  exportColumns: any[] = [
    { cellClass: "cellCenter", headerCheckboxSelection: true, checkboxSelection: true, maxWidth: 65 },
    { headerName: "First Name", field: "firstName" },
    { headerName: "Last Name", field: "lastName", cellStyle: { textAlign: 'center' }, hide: true, supressToolPanel: true },
    { headerName: "Phone No", field: "primaryPhoneNo", cellStyle: { textAlign: 'center' } },
    { headerName: "Pan Card No.", field: "panCardNo", cellStyle: { textAlign: 'center' }, hide: true, supressToolPanel: true },

  ];
  columnKeys: any[] = ['firstName', 'lastName', 'primaryPhoneNo',];

  constructor(private toasterService: ToasterService, private route: ActivatedRoute, private router: Router, private saleservice: SalesService,
    public commonService: CommonService, public userService: UserService,
    public modalService: ModalService, private ngxSpinnerService: NgxSpinnerService) {
    { this.context = this }
  }

  ngOnInit() {
    this.userService.isCustomerData = false;
    this.agGridHeaderList()
    this.agGridHeaderFilter()
  }


  onSelectedRowsChange(selectedRows: any) {
    this.selectedExportData = [];
    let exportedObject: any[] = [];

    selectedRows.forEach((row: any) => {
      let customerDetailObject = row;
      if (customerDetailObject) {
        let rowData = {
          "Name": customerDetailObject.clientName,
          "Phone Number": customerDetailObject.primaryPhoneNo_Copy,
          "Pan Card": customerDetailObject.panCardNo_Copy,
          "Aadhar Card": customerDetailObject.aadharNumber
        };
        exportedObject.push(rowData);
      }
    });

    this.selectedExportData = exportedObject;
  }



  /**
   * Ag grid Header List
   */
  agGridHeaderList() {

    this.columnDefs = [
      {
        field: 'selection', columnType: 'checkbox'
      },
      { header: "Name", field: "clientName", columnType: 'text' },
      { header: "Phone No", field: "primaryPhoneNo", columnType: 'phone' },
      { header: "Pan Card No", field: "panCardNo", columnType: 'text' },
      {
        header: "Actions", field: "options", columnType: 'dropdown', options: [
          { label: 'Edit', value: 'edit', icon: this.editIcon }
        ]
      }

    ];
  }



  /**
   * Ag Grid Header Filter/Sorting
   */
  agGridHeaderFilter() {
    this.defaultColDef = {
      editable: false,
      sortable: true,
      filter: true,
      resizable: false,
    };
  }

  //Showing modal on click of add customer button
  changeAddUpdateModalState(currentRecord?: any, type?: any, context?: any) {
    this.changeModelStatus.emit({
      currentRecord: (type == "mobileView") ? currentRecord : (currentRecord?.currentRow),
      showaddUpdateModal: true,
      // context:context
    });
  }
  //Showing modal on click of add customer button
  changeAddUpdateModalMobileView(currentRecord?: any, context?: any) {
    this.changeModelStatus.emit({
      currentRecord: currentRecord,
      showaddUpdateModal: true,
      // context:context
    });
  }
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  /**
   * Set values for bank which is in add and edit modal
   * @param {any} data
   */
  setValues(data: any) {
    if (data) {
      this.showOverlay = false;
    }
  }

  /**
   * @param data Set Data Mobile View Export Excel/PDF
   */
  exportValues(data: any) {
    if (data) {
      this.showExport = false;
    }
    [
      { field: "selection", columnType: 'checkbox' },
      { header: "First Name", field: "firstName", columnType: "text" },
      { header: "Last Name", field: "lastName", columnType: "text" },
      { header: "Phone No", field: "primaryPhoneNo", columnType: "text" },
      { header: "Pan Card No.", field: "panCardNo", columnType: "text" },
      {
        header: "Actions", field: "options", columnType: "dropdown",
        options: [
          { label: 'Edit', value: 'edit', icon: environment.assetsImagePath + IconList.EditIconDropdown }
        ]

      }
    ]
  }

  //to hide the export common component when needed
  hideExport() {
    this.showExport = false;
    $('.modal').modal('hide');
  }

  Close() {
    this.Submitted = false
    this.isVisible = false;
  }

  /**
   *
   * @param type toggle the export button and redirect the open common export-component
   */
  toggleExport(type: string) {
    this.exportSelectedType = type;
    this.showExport = !this.showExport;
  }

}
